import type { Crop } from 'react-image-crop'

interface ImageProps {
  img: HTMLImageElement
  imgRef: React.MutableRefObject<HTMLImageElement | null>
  setCrop: ({ unit, width, height, x, y }: Crop) => void
  setNewCompletedCrop: ({ unit, width, height, x, y }: Crop) => void
}

/**
 * This function is used to set the dimension of a cropped image.
 */
export const loadImage = (props: ImageProps) => {
  const { imgRef, img, setCrop, setNewCompletedCrop } = props
  imgRef.current = img

  const originalWidth = img.width
  const originalHeight = img.height
  const aspect = 1 / 1
  const width = img.width / aspect < img.height * aspect ? 100 : ((img.height * aspect) / img.width) * 100
  const height = img.width / aspect > img.height * aspect ? 100 : (img.width / aspect / img.height) * 100
  const y = (100 - height) / 2
  const x = (100 - width) / 2

  const calculatedCropWidth = (originalWidth * width) / 100
  const calculatedCropHeight = (originalHeight * height) / 100
  const calculatedCropX = (originalWidth * x) / 100
  const calculatedCropY = (originalHeight * y) / 100

  setCrop({ height, unit: '%', width, x, y })

  setNewCompletedCrop({
    height: calculatedCropHeight,
    unit: 'px',
    width: calculatedCropWidth,
    x: calculatedCropX,
    y: calculatedCropY
  })
}
